export type RewardType = 'coins' | 'gems' | 'tickets' | 'box' | 'prism' | 'special';

export interface SingleReward {
  type: RewardType;
  subType?: string; // For boxes ('bronze', 'silver', etc.) or tickets ('star')
  amount: number;
  label?: string;
  stars?: number; // For prisms
}

export type DailyReward = SingleReward | SingleReward[];

export interface RewardDay {
  free: DailyReward;
  premium: DailyReward;
}

export const DAILY_REWARD_TRACK: RewardDay[] = [
  // Week 1
  { 
    free: { type: 'coins', amount: 1000, label: '1,000 Coins' },
    premium: { type: 'prism', amount: 1, stars: 2, label: '2-Star Anima Ticket' }
  },
  {
    free: { type: 'tickets', amount: 1, label: '1 Heart Ticket' },
    premium: { type: 'coins', amount: 3000, label: '3,000 Coins' }
  },
  {
    free: { type: 'prism', amount: 1, stars: 1, label: '1-Star Anima Ticket' },
    premium: { type: 'prism', amount: 1, stars: 2, label: '2-Star Anima Ticket' }
  },
  {
    free: { type: 'coins', amount: 1500, label: '1,500 Coins' },
    premium: { type: 'tickets', amount: 2, label: '2 Heart Tickets' }
  },
  {
    free: { type: 'tickets', amount: 1, label: '1 Heart Ticket' },
    premium: { type: 'prism', amount: 1, stars: 2, label: '2-Star Anima Ticket' }
  },
  {
    free: { type: 'prism', amount: 1, stars: 2, label: '2-Star Anima Ticket' },
    premium: { type: 'coins', amount: 2500, label: '2,500 Coins' }
  },
  {
    free: { type: 'box', subType: 'bronze', amount: 1, label: '1 Bronze Box' },
    premium: { type: 'box', subType: 'gold', amount: 1, label: '1 Gold Box' }
  },
  // Week 2
  {
    free: { type: 'coins', amount: 2000, label: '2,000 Coins' },
    premium: { type: 'gems', amount: 50, label: '50 Hoshi' }
  },
  {
    free: { type: 'prism', amount: 1, stars: 1, label: '1-Star Anima Ticket' },
    premium: { type: 'prism', amount: 1, stars: 2, label: '2-Star Anima Ticket' }
  },
  {
    free: { type: 'tickets', amount: 2, label: '2 Heart Tickets' },
    premium: { type: 'tickets', subType: 'star', amount: 1, label: '1 Star Ticket' }
  },
  {
    free: { type: 'box', subType: 'bronze', amount: 1, label: '1 Bronze Box' },
    premium: { type: 'prism', amount: 1, stars: 3, label: '3-Star Anima Ticket' }
  },
  {
    free: { type: 'gems', amount: 50, label: '50 Hoshi' },
    premium: { type: 'gems', amount: 100, label: '100 Hoshi' }
  },
  {
    free: { type: 'prism', amount: 1, stars: 2, label: '2-Star Anima Ticket' },
    premium: { type: 'prism', amount: 1, stars: 3, label: '3-Star Anima Ticket' }
  },
  {
    free: { type: 'box', subType: 'silver', amount: 1, label: '1 Silver Box' },
    premium: { type: 'tickets', subType: 'star', amount: 1, label: '1 Star Ticket' }
  },
  // Week 3
  {
    free: { type: 'coins', amount: 3000, label: '3,000 Coins' },
    premium: { type: 'prism', amount: 1, stars: 3, label: '3-Star Anima Ticket' }
  },
  {
    free: { type: 'prism', amount: 1, stars: 2, label: '2-Star Anima Ticket' },
    premium: { type: 'gems', amount: 100, label: '100 Hoshi' }
  },
  {
    free: { type: 'tickets', amount: 3, label: '3 Heart Tickets' },
    premium: { type: 'tickets', subType: 'star', amount: 1, label: '1 Star Ticket' }
  },
  {
    free: { type: 'prism', amount: 1, stars: 3, label: '3-Star Anima Ticket' },
    premium: { type: 'prism', amount: 1, stars: 3, label: '3-Star Anima Ticket' }
  },
  {
    free: { type: 'box', subType: 'silver', amount: 1, label: '1 Silver Box' },
    premium: { type: 'box', subType: 'gold', amount: 1, label: '1 Gold Box' }
  },
  {
    free: { type: 'coins', amount: 4000, label: '4,000 Coins' },
    premium: { type: 'coins', amount: 10000, label: '10,000 Coins' }
  },
  {
    free: { type: 'box', subType: 'gold', amount: 1, label: '1 Gold Box' },
    premium: { type: 'box', subType: 'diamond', amount: 1, label: '1 Diamond Box' }
  },
  // Week 4
  {
    free: { type: 'prism', amount: 1, stars: 2, label: '2-Star Anima Ticket' },
    premium: { type: 'prism', amount: 1, stars: 3, label: '3-Star Anima Ticket' }
  },
  {
    free: { type: 'gems', amount: 100, label: '100 Hoshi' },
    premium: { type: 'gems', amount: 150, label: '150 Hoshi' }
  },
  {
    free: { type: 'box', subType: 'gold', amount: 1, label: '1 Gold Box' },
    premium: { type: 'coins', amount: 10000, label: '10,000 Coins' }
  },
  {
    free: { type: 'prism', amount: 1, stars: 3, label: '3-Star Anima Ticket' },
    premium: { type: 'prism', amount: 1, stars: 3, label: '3-Star Anima Ticket' }
  },
  {
    free: { type: 'tickets', subType: 'star', amount: 1, label: '1 Star Ticket' },
    premium: { type: 'prism', amount: 1, stars: 3, label: '1x 3-Star Anima Ticket' }
  },
  {
    free: { type: 'coins', amount: 5000, label: '5,000 Coins' },
    premium: { type: 'box', subType: 'gold', amount: 1, label: '1 Gold Box' }
  },
  {
    free: { type: 'box', subType: 'diamond', amount: 1, label: '1 Diamond Box' },
    premium: { type: 'gems', amount: 200, label: '200 Hoshi' }
  }
];

export const getRewardLabel = (reward: DailyReward): string => {
  if (Array.isArray(reward)) {
    return reward.map(r => r.label || `${r.amount}x ${r.type}`).join(' + ');
  }
  return reward.label || `${reward.amount}x ${reward.type}`;
};
